export function allowEnterInTextarea() {
  document.addEventListener(
    "keydown",
    (e) => {
      if (e.key !== "Enter") return

      const t = e.target
      if (!t) return

      if (t.tagName === "TEXTAREA" || t.isContentEditable) {
        e.stopImmediatePropagation()
      }
    },
    true
  )
}
